export class TextEditorSettings {
  constructor(
    public appearance: 'input' | 'textarea' = 'input',
    public usePipe: boolean = true
  ) {}
}
